export class MascaraCpf {
  aplicar(event: any): string {
    const rawValue = event.target.value.replace(/\D/g, '').slice(0, 11);
    let formatted = '';
    if (rawValue.length > 0) {
      formatted = rawValue.replace(
        /(\d{3})(\d{0,3})(\d{0,3})(\d{0,2})/,
        function (match, p1, p2, p3, p4) {
          let result = p1;
          if (p2) result += '.' + p2;
          if (p3) result += '.' + p3;
          if (p4) result += '-' + p4;
          return result;
        }
      );
    }
    return formatted;
  }
}
